import { render, staticRenderFns } from "./discussTheTopicModel.vue?vue&type=template&id=509eba87"
import script from "./discussTheTopicModel.vue?vue&type=script&lang=js"
export * from "./discussTheTopicModel.vue?vue&type=script&lang=js"
import style0 from "./discussTheTopicModel.vue?vue&type=style&index=0&id=509eba87&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports